import React from 'react';

const ImageLink = ({onInput,onSubmit}) => {
    return (
        <div style={{marginTop: '-6%'}}>
            <p className='f1'>
                {'Welcome to faceDetect.'}
            </p>
            <p className='f5'>
                {'Paste a link in the box and press detect to detect the face in the picture.'}
            </p>
            <div>
                <input type = 'text' className='f4 pa2 w-50 center' style={{border:'none', borderRadius: '20px'}} onChange={onInput}/>
                <button className='w-8 mh3 grow f4 link ph3 pv2 dib black' style={{border:'none', borderRadius: '20px'}} onClick={onSubmit}>DETECT</button>
            </div>
            <p className='f6'>Works with pictures having a single face.</p>
        </div>

    );
}

export default ImageLink;